/* eslint-disable @typescript-eslint/camelcase */
import _ from 'lodash'
import { getSectionId } from './getSectionData'

const retrieveParentProperties = (site) => {
  let parentPath = '/'
  if (site) {
    const currPath = site.path || getSectionId(site)
    parentPath = currPath.slice(0, currPath.lastIndexOf('/')) || '/'
  }
  return {
    parent_id: parentPath,
    parent: {
      default: parentPath,
    },
  }
}

const setParentSitePrimariesToMultisite = (websiteId, legacyPrimaries) => {
  //  convert legacy stories that had only string entries for `additional_properties.parent_site_primaries` to objects
  return legacyPrimaries.map((strSecondary) => {
    if (typeof strSecondary === 'string') {
      return {
        websiteId: websiteId,
        sectionId: strSecondary,
      }
    }
    return strSecondary
  })
}

export const setPrimarySection = (primarySite, websiteId) => {
  if (primarySite.type === 'reference') {
    return {
      type: 'reference',
      referent: {
        ...primarySite.referent,
        type: 'section',
        website: websiteId,
      },
    }
  }
  const parentProps = retrieveParentProperties(primarySite)
  return {
    ...primarySite,
    ...parentProps,
    type: 'section',
    _website: websiteId,
  }
}

export const setTaxonomySections = (websiteId, sites) => {
  return sites.map((site) => {
    if (site.type === 'reference') {
      return {
        type: 'reference',
        referent: {
          ...site.referent,
          type: 'section',
        },
      }
    }

    const parentProps = retrieveParentProperties(site)

    return {
      ...site,
      ...parentProps,
      type: 'section',
      _website: websiteId,
    }
  })
}

const getDefaultWebsite = (websitesList) => {
  const defaultWebsite = _.find(
    websitesList,
    (website) => website.is_default_website
  )
  return _.get(defaultWebsite, '_id', null)
}

export const addMultisiteFields = (story, websitesList) => {
  const defaultWebsiteId = getDefaultWebsite(websitesList)
  // Skip migration if no default website exsist
  if (!defaultWebsiteId) return story
  const websiteIds = _.values(_.mapValues(websitesList, '_id'))
  const isMultisite = websiteIds.length > 1
  const {
    canonical_website: canonicalWebsite,
    canonical_url: canonicalUrl,
    taxonomy,
  } = story
  const {
    primary_site: primarySite,
    primary_section: primarySection,
    additional_properties: additionalProperties = {},
    sites,
    sections,
  } = taxonomy
  const { parent_site_primaries: legacyPrimaries } = additionalProperties

  const newStory = Object.assign({}, story)

  websiteIds.forEach((websiteId) => {
    if (websiteId !== defaultWebsiteId && isMultisite) return
    let isLegacyStory = false
    if (sites && sites.length && !sections) {
      _.set(
        newStory,
        `taxonomy.sections`,
        setTaxonomySections(websiteId, sites)
      )
      isLegacyStory = true
    }
    if (primarySite && !primarySection) {
      const newPrimarySection = setPrimarySection(primarySite, websiteId)
      _.set(
        newStory,
        `websites[${websiteId}].website_section`,
        newPrimarySection
      )
      _.set(newStory, `taxonomy.primary_section`, newPrimarySection)
      isLegacyStory = true
    }
    // cleaning up bad template data where references were saved along with parent info; this isn't common.
    if (
      primarySite &&
      primarySection &&
      primarySection.parent &&
      primarySection.referent
    ) {
      const newPrimarySection = setPrimarySection(primarySite, websiteId)
      _.set(newStory, `taxonomy.primary_section`, newPrimarySection)
    }
    if (legacyPrimaries) {
      _.set(
        newStory,
        `taxonomy.additional_properties.parent_site_primaries`,
        setParentSitePrimariesToMultisite(websiteId, legacyPrimaries)
      )
    }
    if (isLegacyStory) {
      if (!canonicalWebsite) {
        newStory.canonical_website = websiteId
      }
      if (canonicalUrl) {
        _.set(newStory, `websites[${websiteId}].website_url`, canonicalUrl)
      }
    }
  })

  return newStory
}
